import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { API } from 'api';
import { OrganizationPurchaseData } from 'features/organizations/organizations.types';

export type UseOrganizationQuoteProps = {
  token?: string;
};

export type UseOrganizationQuote = Omit<
  UseQueryResult<OrganizationPurchaseData, Error>,
  'data'
> & {
  quote?: OrganizationPurchaseData;
};

const fetchOrganizationQuote = async (
  token?: string,
): Promise<OrganizationPurchaseData> => {
  const response = await API.get('organization/purchase/quote/', {
    params: { token },
  });
  return response.data;
};

export const useOrganizationQuote = (
  props: UseOrganizationQuoteProps,
): UseOrganizationQuote => {
  const { token } = props;

  const { data: quote, ...results } = useQuery<OrganizationPurchaseData, Error>(
    {
      queryKey: ['organizationQuote', token],
      queryFn: () => fetchOrganizationQuote(token),
      enabled: Boolean(token),
      staleTime: 60 * 60 * 1000,
    },
  );

  return {
    ...results,
    quote,
  };
};
